import React,{useEffect} from "react";
import SideBar from "../../../components/sidebar/sidebar";
import WatningContainer from "../warningContainer/warningContainer"
import VideoCard from "../videoCard/videoCard"

import "./ExamSideNav.scss"
const ExamSideNav = () => {

    useEffect(() => {
      
      return () => {
        
      }
    }, [])  
    
    
    return (

    <>
      <SideBar>
        <div className="exam-sidebar-content vh-100 d-flex flex-column">
        <div className="sidebar-nav">
          <ul className="side-nav"></ul>
        </div>
        <span className="small-nav-handle">
          <i className="fa fa-outdent"></i>
        </span>
        <div className="w-100 d-flex justify-content-center">
        <VideoCard/>
        </div>
         <WatningContainer/>
        </div>
      </SideBar>
    </>
  );
};

export default ExamSideNav;
